import { FormInstance } from 'antd';
import { LocalizedEditEntranceTicketTypeInput } from 'apollo/localizedTypes';
import mapLocalizedText from 'utils/i18n/mapLocalizedText';
import mapOptionalLocalizedRichText from 'utils/i18n/mapOptionalLocalizedRichText';
import { EntranceTicketTypeCreate, EntranceTicketTypeEdit } from '../types';

const entranceConfigurationFormToInput = (
  form: FormInstance
): EntranceTicketTypeEdit | EntranceTicketTypeCreate => {
  const formValues = form.getFieldsValue(true) as LocalizedEditEntranceTicketTypeInput;
  const mappedFormValues = {
    name: mapLocalizedText(formValues.name),
    adultValue: Number(formValues.adultValue),
    otherValue: Number(formValues.otherValue),
    maxStock: Number(formValues.maxStock),
    description: mapOptionalLocalizedRichText(formValues.description),
    features: formValues.features || [],
    isBicycle: formValues.isBicycle,
  };
  return mappedFormValues;
};

export default entranceConfigurationFormToInput;
